// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__16pSg","title":"Images45_title__3U639","images":"Images45_images__2nvcD"};